export default __webpack_public_path__ + "static/media/back.d7caf67b.png";